import { memo, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { LeftOutlined } from '@ant-design/icons';
import { Button, Layout } from 'antd';
import cn from 'classnames';

import {
    getGoogleProcessingPath,
    getResetPasswordPath,
    getSignInPath,
} from '@/shared/constants/router';
import { LanguageSwitcher } from '@/shared/ui/language-switcher';

import cls from './auth-header.module.css';

interface AuthHeaderProps {
    pathRoute: string;
    className?: string;
}

export const AuthHeader = memo((props: AuthHeaderProps) => {
    const { className, pathRoute } = props;

    const navigate = useNavigate();

    const onClick = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    const needShowGoBackButton = useMemo(
        () =>
            !pathRoute.includes(getSignInPath()) &&
            !pathRoute.includes(getResetPasswordPath()),
        [pathRoute],
    );

    if (pathRoute === getGoogleProcessingPath()) {
        return null;
    }

    return (
        <Layout.Header className={cn(cls.root, className)}>
            {needShowGoBackButton && (
                <Button
                    className={cls.goBackBtn}
                    icon={<LeftOutlined />}
                    onClick={onClick}
                    shape="circle"
                    size="large"
                />
            )}

            <LanguageSwitcher
                className={cls.langSwitcher}
                isAuth
            />
        </Layout.Header>
    );
});

AuthHeader.displayName = 'AppHeader';
